
        var result = require("!!../../../../node_modules/css-loader/index.js!./base.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./ClientApp/app/components/base/base.component.css
// module id = 462
// module chunks = 0